import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { hotTopics } from '@/mocks/hotTopics';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionTitle from '@/components/feature/SectionTitle';

export default function HotTopicsSection() {
  const moreArticles = articles.slice(5, 11);

  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <SectionTitle
              title="更多爆料"
              subtitle="MORE"
              action={{ label: '浏览全部', href: '/category/meiri-chigua' }}
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {moreArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>

          <div className="lg:col-span-1">
            <SectionTitle title="热门话题" subtitle="HOT TOPICS" />
            <div className="bg-background-100 rounded-xl border border-background-200/70 p-4 md:p-5">
              <div className="space-y-3">
                {hotTopics.map((topic, index) => (
                  <div
                    key={topic.id}
                    className="flex items-center gap-3 py-2 border-b border-background-200/50 last:border-0"
                  >
                    <span
                      className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                        index < 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {index + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground-800 truncate">{topic.title}</p>
                      <p className="text-xs text-foreground-400 mt-0.5">
                        热度 {topic.heat > 10000 ? `${(topic.heat / 10000).toFixed(1)}万` : topic.heat}
                      </p>
                    </div>
                    <span
                      className={`text-xs flex-shrink-0 ${
                        topic.trend === 'up'
                          ? 'text-primary-500'
                          : topic.trend === 'down'
                            ? 'text-foreground-400'
                            : 'text-accent-500'
                      }`}
                    >
                      {topic.trend === 'up' && <i className="ri-arrow-up-line" />}
                      {topic.trend === 'down' && <i className="ri-arrow-down-line" />}
                      {topic.trend === 'stable' && <i className="ri-arrow-right-line" />}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-6 bg-accent-50 rounded-xl border border-accent-200/50 p-5">
              <h4 className="text-sm font-semibold text-accent-900 mb-3 flex items-center gap-2">
                <i className="ri-fire-line" />
                今日吃瓜指数
              </h4>
              <div className="space-y-3">
                <div>
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-foreground-600">网红塌房</span>
                    <span className="font-semibold text-primary-600">92%</span>
                  </div>
                  <div className="w-full h-2 bg-background-200 rounded-full overflow-hidden">
                    <div className="h-full bg-primary-500 rounded-full" style={{ width: '92%' }} />
                  </div>
                </div>
                <div>
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-foreground-600">明星恋情</span>
                    <span className="font-semibold text-accent-600">85%</span>
                  </div>
                  <div className="w-full h-2 bg-background-200 rounded-full overflow-hidden">
                    <div className="h-full bg-accent-500 rounded-full" style={{ width: '85%' }} />
                  </div>
                </div>
                <div>
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-foreground-600">平台黑幕</span>
                    <span className="font-semibold text-secondary-600">78%</span>
                  </div>
                  <div className="w-full h-2 bg-background-200 rounded-full overflow-hidden">
                    <div className="h-full bg-secondary-500 rounded-full" style={{ width: '78%' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}